export const DEFAULT_NUMBER_STORIES = 20;
export const DEFAULT_AUTHOR_IMAGE_QUALITY = 120;
export const DEFAULT_PAGE_NUMBER = 1;
